﻿<template>
  <div
      ref="modalElement"
      class="modal fade"
      tabindex="-1"
      :aria-labelledby="ariaLabelId"
      aria-hidden="true"
  >
    <div :class="dialogClass">
      <aunoa-form
          v-if="visible"
          class="modal-content"
          :autocomplete="autocomplete"          
          :mode="mode"
      >
        <div class="modal-header shadow-sm" v-if="$slots.header">
          <slot name="header" :title="title" />
        </div>
        <div class="modal-header" :class="headerClass" v-else-if="title || !disableCloseButton">
          <h5 class="modal-title" v-text="title" :id="ariaLabelId" />
          <button
              v-if="!disableCloseButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCancel"
          />
        </div>
        <div class="modal-body container-fluid pt-2 pb-4 px-3 ms-0" ref="bodyElement">
          <aunoa-text-box
              icon="fa-envelope"
              subType="email"
              v-model="email"
            />
        </div>        
        <div class="modal-footer p-0" :class="footerClass">
          <aunoa-nav class="p-0 m-0">
            <aunoa-nav-item
                type="submit"
                :text="ensureTextTranslated(applyText||'@@Aunoa.Command.Apply')"
                @click="onApply"
            />
            <aunoa-nav-item
                :text="ensureTextTranslated(cancelText||'@@Aunoa.Command.Cancel')"
                @click="onCancel"
            />
          </aunoa-nav>

        </div>
      </aunoa-form>
    </div>
  </div>
</template>

<script lang="ts">

import type {PromisableEvent} from "../types";

import {defineComponent, ref, computed} from "vue";
import AunoaForm from "../components/form/AunoaForm.vue";
import {getVisibilityEventNames} from "../utils/useVisibilityEvents";
import AunoaFormGroup from "../components/form/AunoaFormGroup.vue";
import {modalPropsOptions, useModal} from "../utils/useModal";
import AunoaNavItem from "../components/nav/AunoaNavItem.vue";
import AunoaNav from "../components/nav/AunoaNav.vue";
import {formPropsCoreOptions} from "../utils/forms";
import {useAunoaI18n} from "../utils/useAunoaI18n";
import AunoaTextBox from "../components/form/AunoaTextBox.vue";


export default defineComponent({
    name: "AunoaModalPrompt",
  components: {
    AunoaTextBox,
    AunoaForm, AunoaFormGroup, AunoaNav, AunoaNavItem
  },
  props: {
    ...modalPropsOptions,
    ...formPropsCoreOptions,
    title: {
      type: String,
      default: undefined
    },
    applyText: {
      type: String,
      default: undefined
    },
    cancelText: {
      type: String,
      default: undefined
    },
    disableCloseButton: {
      type: Boolean,
      default: false
    },
    headerClass: {},
    footerClass: {}
  },
  emits: ["apply", ...getVisibilityEventNames("modal")],
  setup(props, {attrs, emit}) {

    const bodyElement = ref();
    const email = ref<string>();

    const {ensureTextTranslated, t} = useAunoaI18n()
    const modal = useModal(<any>props, emit);

    const ariaLabelId = computed(() =>
        attrs.id && modal.visible.value && props.title
            ? attrs.id + "Label"
            : undefined);

    const onApply = (event: PromisableEvent) => {
      const classList = bodyElement.value.classList;
      const emitPromise = new Promise<{ busyPromise: Promise<any> }>(resolve => {
        const setPromise = event.setPromise;
        event.setPromise = (promise, options) => {
          classList.toggle("bg-loading", true);
          promise
              .catch()
              .finally(() => {
                classList.toggle("bg-loading", false);
              });
          const busyPromise = setPromise(promise, options);
          resolve({busyPromise});
          return busyPromise;
        }
        resolve({busyPromise: Promise.resolve()});
      })
      
      emitPromise
          .then(({busyPromise}) => {
                busyPromise.then(() => {
                  email.value="";
                  modal.hide();
                }).catch();
              }
          );
      emit("apply", event, email.value);
    }

    const onCancel = (event: PointerEvent) =>
        modal.hide();

    const show = () => {
      modal.show();
    }


    return {
      t,
      ...modal,
      email,
      bodyElement,
      ensureTextTranslated,
      ariaLabelId,
      show,

      onApply,
      onCancel
    }
  }
});

</script>


